import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider } from "@/context/LanguageContext";
import Header from "@/components/Header";
import HomePage from "@/pages/Home";
import ReadingPage from "@/pages/Reading";
import WelcomePage from "@/pages/Welcome";
import DailyPage from "@/pages/Daily";
import ContactPage from "@/pages/Contact";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <div className="grain-overlay" />
      <div className="vignette" />
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/welcome" element={<WelcomePage />} />
            <Route path="/daily" element={<DailyPage />} />
            <Route path="/reading" element={<ReadingPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster
            theme="light"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#FAF3E0",
                color: "#14103A",
                border: "1px solid rgba(138,90,15,0.5)",
                fontFamily: "Outfit, sans-serif",
              },
            }}
          />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
